import React from "react";
import { Box, IconButton } from "@chakra-ui/react";
import { MdPlayArrow, MdAdd, MdStop } from "react-icons/md";
import { useTimerTracker } from "../hooks/useTimeTracker";

type TimerSelectorProps = Pick<useTimerTracker.type, 'state' | 'switchType' | 'confirmTimer'>;

const TimerSelector: React.FC<TimerSelectorProps> = ({ state, switchType, confirmTimer }) => {

    const timerIsRunning = state.timer?.initialMoment != null && state.timer?.finalMoment == null;

    return (
        <>
            <IconButton
                aria-label="Iniciar contagem"
                colorScheme='brand'
                size={"lg"}
                rounded="full"
                variant='solid'
                mr={4}
                onClick={confirmTimer}
                isDisabled={state.loading}
                backgroundColor={timerIsRunning && state.inputType === 'auto' ? 'red.500' : 'green.500'}
            >
                {timerIsRunning && state.inputType === 'auto' ? <MdStop /> : <MdPlayArrow />}
            </IconButton>

            <Box
                display="flex"
                flexDirection={"column"}
                alignItems="center"
                gap={4}
                p={2}
                borderRadius={"full"}
                backgroundColor={'gray.200'}
            >
                <IconButton
                    aria-label="Modo Auto"
                    colorScheme='brand'
                    size={"xs"}
                    rounded="full"
                    variant='solid'
                    isDisabled={state.inputType === 'auto' || timerIsRunning}
                    onClick={() => switchType('auto')}
                >
                    <MdPlayArrow />
                </IconButton>

                <IconButton
                    aria-label="Modo Manual"
                    colorScheme='brand'
                    size={"xs"}
                    rounded="full"
                    variant='solid'
                    isDisabled={state.inputType === 'manual' || timerIsRunning}
                    onClick={() => switchType('manual')}
                >
                    <MdAdd />
                </IconButton>
            </Box>
        </>
    );
};

export default TimerSelector;
